import { KLAUS_AI_CATEGORY_KEYS } from '@app/constants/klaus';
import { NO_SELECTION_SENTINEL } from '@app/constants/snippetCategoryKeys';
import { useMemo } from 'react';
import { useUserValuesData } from './useUserValuesData';

/**
 * Detects whether the company declared AI-related services in the privacy-policy questionnaire.
 *
 * The service selection is persisted per company by `preQuestionsUpdate` on the server: one
 * PersistentState row per category key, value is a JSON array of service names (or the
 * NO_SELECTION_SENTINEL when the user confirmed "none"). Any non-empty selection in one of the
 * AI categories counts — we deliberately do not differentiate by provider.
 */
export function useKlausAiSignal() {
  const { userValues } = useUserValuesData();

  const tools = useMemo(() => {
    if (!userValues) return [];
    const names = KLAUS_AI_CATEGORY_KEYS.flatMap((key) => {
      const userValue = userValues.find((uv) => uv.key === key && uv.index === 'UNIQUE');
      if (!userValue || userValue.value === NO_SELECTION_SENTINEL) return [];
      try {
        const parsed = JSON.parse(userValue.value);
        return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
      } catch {
        return [];
      }
    });
    return [...new Set(names)];
  }, [userValues]);

  return { hasAiSignal: tools.length > 0, tools };
}
